<template>
  <div class="overall2 HEIGHTAUTO">
    <div class="overall2_case">
      <span style="font-size: 16px">
        <el-tooltip
          class="item"
          effect="dark"
          content="分板块指数表示根据上一个交易日的流通份额计算的流通市值加权后当日板块指数"
          placement="top">
          <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
        </el-tooltip>
        指标说明
      </span>
    </div>
    <div
      class="total_counts"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)">
      <div
        v-if="total_counts['drop']['per'] > total_counts['rise']['per']"
        class="drop"
        :style="'width:' + total_counts['drop']['per'] + '%'">
        <div class="t">
          下跌<span>{{ total_counts['drop']['count'] }}</span>
        </div>
        <div class="grap"></div>
      </div>
      <div v-else class="rise" :style="'width:' + total_counts['rise']['per'] + '%'">
        <div class="t">
          上涨<span>{{ total_counts['rise']['count'] }}</span>
        </div>
        <div class="grap"></div>
      </div>
      <div class="draw" :style="'width:' + total_counts['draw']['per'] + '%'">
        <div class="t">
          平<span>{{ total_counts['draw']['count'] }}</span>
        </div>
        <div class="grap"></div>
      </div>
      <div
        v-if="total_counts['drop']['per'] <= total_counts['rise']['per']"
        class="drop"
        :style="'width:' + total_counts['drop']['per'] + '%'">
        <div class="t">
          下跌<span>{{ total_counts['drop']['count'] }}</span>
        </div>
        <div class="grap"></div>
      </div>
      <div v-else class="rise" :style="'width:' + total_counts['rise']['per'] + '%'">
        <div class="t">
          上涨<span>{{ total_counts['rise']['count'] }}</span>
        </div>
        <div class="grap"></div>
      </div>
    </div>
    <div
      class="echarts_tree"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)">
      <div class="canvasAreaTree" ref="echart_tree"></div>
    </div>
    <div
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"
      class="echarts_AREA">
      <div class="canvasArea3" v-for="(node, index) in dCalSingleReitIndex_Ys" :key="index">
        <div :id="node.name" style="height: 300px" @click="switchTo(node.name)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fnReturnTableStyle } from '@/utils/util';

export default {
  name: 'SubSection',
  components: {},
  data() {
    return {
      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
      ROOTFONTFIZE: '',

      loading: false,
      dCalSingleReitIndex_Ys: [],

      // ---------20250807----------
      total_counts: {
        drop: {
          per: 0,
          count: 34,
        },
        draw: {
          per: 0,
          count: 1,
        },
        rise: {
          per: 0,
          count: 36,
        },
      },
      echart_tree: null,
      list: [
        {
          name: '跌',
          value: 0,
          children: [],
        },
        {
          name: '涨',
          value: 0,
          children: [],
        },
        {
          name: '平',
          value: 0,
          children: [],
        },
      ],
    };
  },
  methods: {
    // 获取当前屏幕宽度
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;

      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;

      window.sessionStorage.setItem('ROOTFONTFIZE', this.ROOTFONTFIZE);
      return;
    },
    resize() {
      this.fnGetWidth();
      this.echart_tree && this.echart_tree.resize();
    },
    styleBindFun() {
      let val = this.$store.state.theme == 'dark' ? true : false;
      return fnReturnTableStyle(val);
    },
    fnGetTheme() {
      console.log('fnGetTheme index');
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },

    fnCTimeButtons_select_val_chart(val) {
      this.start_date_chart = val;
      this.fnGetCalSingleReitIndex();
    },
    async fnGetCalSingleReitIndex() {
      this.loading = true;

      const { data } = await this.$inday
        .get('/api/board/inday-index?weight=prevclose')
        .catch(() => {
          return this.$https.get('/api/v2_5/reit_category_inday_index?limit=30');
        });
      if (data.code !== 200) return this.$message.error(data.msg);

      let dataTmp = data.data;

      // 步骤1：提取x轴数据,并且提取最大值以及最小值
      let max = 0;
      let min = 2;
      let arrX = [];
      dataTmp.forEach((node) => {
        arrX.push(node.tr_date);
        for (var key in node) {
          if (key == 'tr_date') {
            continue;
          }
          if (node[key] >= max) {
            max = node[key];
          }
          if (node[key] <= min) {
            min = node[key];
          }
        }
      });
      this.max = max.toFixed(4);
      this.min = min.toFixed(4);

      // 步骤2：提取值作为y轴数据，组成一组数据
      // let arr2 = Object.keys(dataTmp[0]);
      // arr2.shift(); // 改变一下这个顺序即可
      let arr2 = [];
      if (dataTmp != undefined && dataTmp.length > 0) {
        arr2 = Object.entries(dataTmp[dataTmp.length - 1]);
        arr2.shift();
      }

      arr2.sort((val1, val2) => {
        return val2[1] - val1[1];
      });
      arr2 = arr2.map((node) => {
        return node[0];
      });

      let FINALLYDATA = [];
      arr2.forEach((node) => {
        let obj = {
          key: node,
          data: [],
        };
        arrX.forEach((item) => {
          dataTmp.forEach((e) => {
            if (e.tr_date == item) {
              obj.data.push(e[node]);
            }
          });
        });

        FINALLYDATA.push(obj);
      });

      let FINALLYDATA_AFTER = [];
      arr2.forEach((node) => {
        let obj = {
          name: node,
          value: FINALLYDATA,
        };
        FINALLYDATA_AFTER.push(obj);
      });
      // console.log('fnGetCalSingleReitIndex', FINALLYDATA_AFTER);

      this.dCalSingleReitIndex_Ys = [];
      this.dCalSingleReitIndex_Ys = FINALLYDATA_AFTER.slice(0, 30);

      this.chart6_arrX = arrX;
      this.initChart();
    },

    initChart() {
      let FINALLYDATA_AFTER = this.dCalSingleReitIndex_Ys;
      let arrX = this.chart6_arrX;

      let COLORSARRAY = [
        {
          name: '中证REITs（全收益）',
          value: '#fff',
        },
        ...this.$store.state.colors,
      ];
      //

      let theme = this.$store.state.theme;

      setTimeout(() => {
        FINALLYDATA_AFTER.forEach((item, index) => {
          this.$nextTick(() => {
            const chartInstance = echarts.init(document.getElementById(item.name));
            chartInstance.clear();

            let seriesArr = item.value.map((node) => {
              return {
                name: node.key,
                data: node.data,
                type: 'line',
                smooth: false,
                symbol: 'none',
                tooltip: {
                  show: node.key == item.name ? true : false,
                },
              };
            });

            let colors = [];
            item.value.forEach((node, idx) => {
              if (item.name == node.key) {
                let obj = COLORSARRAY.filter((node) => {
                  return node.name == item.name;
                });
                if (item.name == '中证REITs（全收益）') {
                  if (theme == 'dark') {
                    colors.push('white');
                  } else {
                    colors.push('gray');
                  }
                } else {
                  colors.push(obj[0].value);
                }
              } else {
                if (theme == 'dark') {
                  colors.push('rgba(118, 118, 118, 0.1)');
                } else {
                  colors.push('rgba(196, 196, 196, 0.1)');
                }
              }
            });

            // console.log('colors', colors);

            let OPTIONDATA =
              this.$store.state.theme == 'dark'
                ? this.$store.state.OPTIONDATA
                : this.$store.state.OPTIONDATA_light;

            let option = {
              grid: {
                left: this.ROOTFONTFIZE * (50 / 144),
                bottom: this.ROOTFONTFIZE * (40 / 144),
              },
              tooltip: {
                trigger: 'axis',
                confine: true,
                triggerOn: 'mousemove|click', // 触发时机, click代表点击, mouseOver代表鼠标移过
                formatter: function (val) {
                  let str = '';
                  val.forEach((node) => {
                    let val = Number(node.value).toFixed(4);
                    // let val = node.value;
                    str += `${node.axisValueLabel}`;
                    str += '<br>';
                    str += `${node.marker}${item.name}:   ${val}`;
                  });

                  return str;
                },
              },
              title: {
                text: item.name, // 标题文字
                textStyle: {
                  color: OPTIONDATA.title.textStyle.color,
                  fontSize: this.ROOTFONTFIZE * (16 / 144),
                },
                top: this.ROOTFONTFIZE * (20 / 144),
                left: this.ROOTFONTFIZE * (20 / 144),
              },
              color: colors,
              xAxis: {
                type: 'category',
                data: arrX,
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                },
                axisLabel: {
                  show: false,
                },
              },
              yAxis: {
                type: 'value',
                axisLine: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  show: true,
                  color: OPTIONDATA.xAxis.axisLabel.color,
                  fontSize: this.ROOTFONTFIZE * (12 / 144),
                },
                max: this.max,
                min: this.min,
              },
              series: seriesArr,
            };

            chartInstance.setOption(option);
            this.loading = false;
          });
        });
      }, 500);
    },
    switchTo(name) {
      this.$parent.switchToSubSectS(name);
    },

    // -----------------------20250807--------------------------------
    async getTreemapCategory() {
      this.loading = true;

      let response;
      try {
        response = await this.$inday.get('/api/board/treemap?level=C2&weight=prevclose');
        const indayTreemap = (((response || {}).data || {}).data || {}).treemap;
        const hasInvalidMarketCap =
          !Array.isArray(indayTreemap) ||
          indayTreemap.length === 0 ||
          indayTreemap.some((item) => {
            const marketCap = Number(item.market_cap);
            const floatMarketCap = Number(item.market_cap_float);
            return (
              !Number.isFinite(marketCap) ||
              !Number.isFinite(floatMarketCap) ||
              marketCap < 0 ||
              floatMarketCap < 0 ||
              marketCap < floatMarketCap
            );
          });
        if (hasInvalidMarketCap) {
          response = await this.$https.get('/api/v2_5/treemap_category');
        }
      } catch (_) {
        response = await this.$https.get('/api/v2_5/treemap_category');
      }
      const { data } = response;
      if (data.code !== 200) return this.$message.error(data.msg);

      let total_counts = data.data.total_counts[0] || { 下跌: 0, 平: 0, 上涨: 0 };
      this.total_counts.drop.count = total_counts['下跌'] || 0;
      this.total_counts.draw.count = total_counts['平'] || 0;
      this.total_counts.rise.count = total_counts['上涨'] || 0;
      let all_total =
        this.total_counts.drop.count + this.total_counts.draw.count + this.total_counts.rise.count;
      this.total_counts.drop.per = ((this.total_counts.drop.count * 99) / all_total).toFixed(1);
      this.total_counts.draw.per = ((this.total_counts.draw.count * 99) / all_total).toFixed(1);
      this.total_counts.rise.per = ((this.total_counts.rise.count * 99) / all_total).toFixed(1);
      let treemap = data.data.treemap;
      //growth_rate：涨跌幅
      //market_cap：市值
      //market_cap_float：流通市值
      //now_amt：成交额
      //这里分出跌、平、涨
      this.list = [
        {
          name: '下跌',
          value: 0,
          children: [],
          color: [],
        },
        {
          name: '上涨',
          value: 0,
          children: [],
          color: [],
        },
        {
          name: '平',
          value: 0,
          children: [],
          color: [],
        },
      ];
      treemap.forEach((item) => {
        const marketCap = Number(item.market_cap);
        if (item.growth_rate < 0) {
          this.list[0].children.push({
            ...item,
            value: marketCap,
            name: item.reit_code,
            // color:['#248b31']
          });
          this.list[0].value += marketCap;
          this.list[0].color.push('#248b31');
        }
        if (item.growth_rate > 0) {
          this.list[1].children.push({
            ...item,
            value: marketCap,
            name: item.reit_code,
          });
          this.list[1].value += marketCap;
          this.list[1].color.push('#b93713');
        }
        if (item.growth_rate == 0) {
          this.list[2].children.push({
            ...item,
            value: marketCap,
            name: item.reit_code,
          });
          this.list[2].value += marketCap;
          this.list[2].color.push('#aeaeae');
        }
      });
      this.$nextTick(() => {
        this.renderEchart();
      });
    },
    renderEchart() {
      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;
      let list = this.list;
      if (!this.echart_tree) {
        this.echart_tree = this.$echarts.init(this.$refs.echart_tree);
      }
      this.echart_tree.clear();
      let option = {
        title: [
          {
            text: '',
            textStyle: {
              // 标题文字样式设置
              // color: this.color_theme,
              color: 'white',
              fontSize: 12,
            },
          },
        ],
        tooltip: {
          formatter: (args) => {
            if (!args.name || !args.data.growth_rate) {
              return;
            }
            let str = '';
            str += `${args.marker}${args.name}：`;
            if (args.data && args.data.now_amt != undefined) {
              str += '<br/>';
              str += `成交额：${(args.data.now_amt / 100000000).toFixed(2)}亿元`;
            }
            if (args.data && args.data.growth_rate != undefined) {
              const growth_rate = args.data.growth_rate;
              const symbol = growth_rate > 0 ? '+' : '';
              str += '<br/>';
              str += `涨幅：${symbol + (growth_rate * 100).toFixed(3)}%`;
            }
            if (args.data && args.data.market_cap != undefined) {
              str += '<br/>';
              str += `市值：${(args.data.market_cap / 10000).toFixed(2)}亿元`;
            }
            if (args.data && args.data.market_cap_float != undefined) {
              str += '<br/>';
              str += `流通市值：${(args.data.market_cap_float / 10000).toFixed(2)}亿元`;
            }
            return str;
          },
        },
        series: {
          type: 'treemap',
          left: 'center',
          // top: 30,
          width: '100%',
          height: '100%',
          // colorSaturation:[0.3,0.5],
          // leafDepth:2,//展示层级
          upperLabel: {
            show: true,
            // position:'inside',
            borderWidth: 0,
            color: OPTIONDATA.xAxis.axisLabel.color,
            fontSize: 18,
            // height:0,
            // rich:{
            //   a:{
            //     height:15,
            //   },
            // },
            borderColor: '#000',
          },
          itemStyle: {
            borderColor: 'transparent',
            borderWidth: 0.5,
            // gapWidth: 1,
            fontSize: 20,
          },
          breadcrumb: {
            //导航
            show: false,
          },
          nodeClick: false, //点击节点行为
          roam: false,
          label: {
            // position: 'insideBottomLeft',
            position: 'insideTopLeft',
            lineHeight: 16,
            itemStyle: {
              color: OPTIONDATA.xAxis.axisLabel.color,
              fontSize: 16,
            },
            // formatter: (label_item) => {
            //   if (!label_item.name) {
            //     return;
            //   }
            //   if(label_item.name=='上涨'||label_item.name=='下跌'||label_item.name=='平'){
            //     return label_item.name;
            //   }
            //   const growth_rate = label_item.data.growth_rate;
            //   const symbol = growth_rate>0?'+':'';
            //   var str = '';
            //   str += label_item.name + '\n';
            //   str += '成交额：'+ (label_item.data.now_amt/100000000).toFixed(2)+'亿元'+ '\n';
            //   str += '涨幅：'+symbol +((growth_rate * 100)).toFixed(3)+'%' + '\n';
            //   str += '市值：'+ (label_item.data.market_cap/10000).toFixed(2)+'亿元'+ '\n';
            //   str += '流通市值：'+ (label_item.data.market_cap_float/10000).toFixed(2)+'亿元';
            //   return  str;
            // },
            formatter: function (params) {
              if (!params.name) {
                return;
              }
              if (params.name == '上涨' || params.name == '下跌' || params.name == '平') {
                return params.name;
              }
              const growth_rate = params.data.growth_rate;
              const symbol = growth_rate > 0 ? '+' : '';
              let arr = [
                '{name|' + params.name + '}',
                '{now_amt|' +
                  '成交额：' +
                  (params.data.now_amt / 100000000).toFixed(2) +
                  '亿元' +
                  '}',
                '{growth_rate|' + '涨幅：' + symbol + (growth_rate * 100).toFixed(3) + '%' + '}',
                '{market_cap|' +
                  '市值：' +
                  (params.data.market_cap / 10000).toFixed(2) +
                  '亿元' +
                  '}',
                '{market_cap_float|' +
                  '流通市值：' +
                  (params.data.market_cap_float / 10000).toFixed(2) +
                  '亿元' +
                  '}',
              ];
              return arr.join('\n');
            },
            rich: {
              name: {
                fontSize: 20,
                lineHeight: 34,
              },
              now_amt: {
                fontSize: 14,
              },
              growth_rate: {
                fontSize: 14,
              },
              market_cap: {
                fontSize: 14,
              },
              market_cap_float: {
                fontSize: 14,
              },
            },
          },
          data: list,
        },
      };
      // console.log("T",list);
      this.echart_tree.setOption(option);
      this.echart_tree.resize();
      this.echart_tree.on('click', this.handleChartClick);
    },
    async handleChartClick(params) {
      this.switchTo(params.name);
    },
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
    this.$nextTick(() => {
      this.getTreemapCategory();
      this.fnGetCalSingleReitIndex();
    });
    this.a = setInterval(() => {
      this.getTreemapCategory();
      this.fnGetCalSingleReitIndex();
    }, 60000);
  },
  beforeDestroy() {},
  computed: {
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.styleBindFun();
      this.fnGetTheme();
      this.$nextTick(() => {
        this.initChart();
        this.renderEchart();
      });
    },
  },
};
</script>

<style scoped lang="less">
.overall2 {
  width: 100%;
  background-color: var(--charts_bgc);

  height: auto;
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  box-sizing: border-box;
}
.chart_title {
  color: var(--chart_title);
  font-size: calc(var(--ROOTFONTFIZE) * (20 / 144));
  font-weight: 700;
  // border-left: 5px solid #1573fe;
  border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
  padding-left: 18px;
  padding-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
  height: calc(var(--ROOTFONTFIZE) * (28 / 144));
  display: flex;
  align-items: center;
}

.chart_title span {
  color: #1573fe;
}

.btnArea {
  display: flex;
  justify-content: center;
  margin-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
}

.echarts_AREA {
  padding-left: calc(var(--ROOTFONTFIZE) * (50 / 144));
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
}

.canvasArea3 {
  width: 20%;
  //   margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  border: none;
}

.chart3_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.overall2_case {
  margin-left: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  color: var(--chart_title);
}
.total_counts {
  padding-left: calc(var(--ROOTFONTFIZE) * (65 / 144));
  margin-bottom: 0px;
  width: 94%;
  height: 40px;
  display: flex;
  .t {
    margin-left: 5px;
    font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
    line-height: 30px;
    color: var(--chart_title);
    span {
      margin-left: 5px;
    }
  }
  .grap {
    width: 100%;
    border: 2px solid var(--chart_title);
    height: 10px;
  }
  .drop {
    width: 50%;
    min-width: 50px;
    span {
      color: #248b31;
    }
    .grap {
      background-color: #248b31;
    }
  }
  .draw {
    width: 10%;
    min-width: 50px;
    margin-left: 0.5%;
    margin-right: 0.5%;
    span {
      color: var(--chart_title);
    }
    .grap {
      background-color: #aeaeae;
    }
  }
  .rise {
    width: 36%;
    min-width: 50px;
    span {
      color: #b93713;
    }
    .grap {
      background-color: #b93713;
    }
  }
}
.canvasAreaTree {
  padding-left: calc(var(--ROOTFONTFIZE) * (65 / 144));
  margin-bottom: 0px;
  width: 94%;
  height: 300px;
}
</style>
